import { render, staticRenderFns } from "./TheBlankLayout.vue?vue&type=template&id=6b6e3d26&"
import script from "./TheBlankLayout.vue?vue&type=script&lang=js&"
export * from "./TheBlankLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports